import { isMobile } from "../../helpers/others";
export const initCtaBanner = () => {
    const button = document.querySelector(".section-14 .cta-widget .btn.sticky");
    if (!button || isMobile())
        return;
    const header = document.querySelector("header.header");
    const headerHeight = header ? header.offsetHeight : 0;
    const buttonParent = button.parentElement;
    const spacer = document.createElement("div");
    spacer.classList.add("sticky-spacer");
    buttonParent.insertBefore(spacer, button);
    const calculateButtonDimensions = () => {
        const buttonInitialWidth = buttonParent.clientWidth - 60;
        const buttonOffsetTop = button.getBoundingClientRect().top + window.scrollY;
        return { buttonInitialWidth, buttonOffsetTop };
    };
    let { buttonInitialWidth, buttonOffsetTop } = calculateButtonDimensions();
    const setButtonStyles = (isSticky) => {
        if (isSticky) {
            spacer.style.display = "block";
            spacer.style.height = `${button.offsetHeight}px`;
            button.style.position = "fixed";
            button.style.top = `${headerHeight}px`;
            button.style.width = `${buttonInitialWidth}px`;
            button.style.left = `${buttonParent.getBoundingClientRect().left + 30}px`;
        }
        else {
            button.style.position = "static";
            spacer.style.display = "none";
        }
    };
    const handleScroll = () => {
        const scrollY = window.scrollY;
        const isSticky = scrollY + headerHeight >= buttonOffsetTop;
        setButtonStyles(isSticky);
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    handleScroll();
};
